module.exports = __webpack_public_path__ + "static/img/selection_3.d907d63d.png";